import React from 'react'
import styled from "styled-components";
import { TextBlock, TextBlockHeading } from "./Common";
import myntra from "../Assets/projects/myntra/myntra.png";
import newegg from "../Assets/projects/newegg/newegg.png";
import pepperfry from "../Assets/projects/Pepperfry/pepperfry.png"


const projectDetails = [
  {
    id: 0,
    img: myntra,
    heading: "Myntra",
    shortDescription:
      "Myntra is a e-commerce store for fashion and lifestyle products. ",
    features:
      " Features that I have added to this projects are Products page, product Detail page, cart and Checkout page.",
    aboutLink: "https://github.com/Vikram-amin/Myntra-Clone.git",
    liveLink: "https://myntra-fashion.netlify.app/",
    stack: [
      "https://img.icons8.com/color/48/000000/html-5.png",
      "https://img.icons8.com/color/48/000000/css3.png",
      "https://img.icons8.com/color/48/000000/javascript.png",
    ],
  },
  {
    id: 1,
    img: newegg,
    heading: "Newegg",
    shortDescription:
      "Newegg.com is a e-commerce company where you can easily buy  IT computer components, consumer electronics and gaming products globally.",
    features:
      " Features that I have added to this projects are Signin, Signup, Products page, product Detail page, cart and Checkout page.",
    aboutLink: "https://github.com/Vikram-amin/newegg.com_clone.git",
    liveLink: "https://newegg-clone.netlify.app/",
    stack: [
      "https://img.icons8.com/color/48/000000/html-5.png",
      "https://img.icons8.com/color/48/000000/css3.png",
      "https://img.icons8.com/color/48/000000/javascript.png",
    ],
  },

  {
    id: 3,
    img: pepperfry,
    heading: "Pepperfry ",
    shortDescription:
      "Pepperfry is an online furniture shopping website which showcases a curated range of home furniture & cutting-edge furniture designs.",
    features:
      " Features that I have added to this projects are Product List API, cart and Checkout page.",
    aboutLink: "https://github.com/Vikram-amin/pepperfry-clone.git",
    liveLink: "https://pepperfry.onrender.com/",
    stack: [
      "Images/reactjs.webp",
      "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      "https://chiranjeev-thapliyal.vercel.app/svg/material-ui.svg",
      "https://img.icons8.com/color/48/000000/nodejs.png",
      "Images/express.webp",
      "Images/mongodb.webp",
    ],
  },
];




function Projects({children}) {
   return (
     <>
       <Wrapper>
         <div>
           <p className="color slider-heading">Checkout my best projects</p>
         </div>
         <hr />
         {projectDetails.map((project) => {
           const {
             id,
             img,
             heading,
             shortDescription,
             aboutLink,
             liveLink,
             features,
             stack,
           } = project;
           return (
             <ProjectComponent
               id={id}
               img={img}
               heading={heading}
               shortDescription={shortDescription}
               features={features}
               stack={stack}
               aboutLink={aboutLink}
               liveLink={liveLink}
             >
               {children}
             </ProjectComponent>
           );
         })}
       </Wrapper>
     </>
   );
}





export const ProjectComponent = ({ img, heading, shortDescription, aboutLink, liveLink,features, stack}) => {
  return (
    <>
      <LocalContainer>
        <ProjectContainer>
          <Image>
            <img src={img} alt="img" />
          </Image>
          <TextContainer>
            <TextBlockHeading>{heading}</TextBlockHeading>
            <TextBlock>{shortDescription}</TextBlock>
            <TextBlock>{features}</TextBlock>
            <Stack>
              {stack.map((link, id) => (
                <img key={id} src={link} alt="" />
              ))}
            </Stack>
            <LinksContainer>
              <a href={aboutLink} target="_blank" rel='noreferrer' className="btn-link effect">
                Github
              </a>
              <a href={liveLink} target="_blank"   rel='noreferrer' className="btn-link effect">
                Check Live
              </a>
            </LinksContainer>
          </TextContainer>
        </ProjectContainer>
      </LocalContainer>
      <hr />
    </>
  );
};





const LocalContainer = styled.main`
  margin: 2rem auto;
  &:hover a svg {
    transform: translateX(2px);
  }
  &:hover a svg path {
    fill: #ff8e00;
  }
`;

const Image = styled.div ``

const ProjectContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 2rem auto;

  @media ${(props) => props.theme.breakpoints.mobile} {
    display: unset;
  }

  img {
width:500px;
  


    @media ${(props) => props.theme.breakpoints.tablet} {
      width: 100%;
    }
  }
`;
const TextContainer = styled.div`
  max-width: 30rem;

  @media ${(props) => props.theme.breakpoints.tablet} {
    margin-left: 2rem;
  }
  @media ${(props) => props.theme.breakpoints.mobile} {
    margin: 1rem 0;
  }
`;

const Wrapper = styled.section`
  max-width: 70rem;
  width: 90%;
  margin: 2rem auto;

  .color {
    color: ${(props) => props.theme.text.main};
  }

  .slider-heading {
    font-size: 2rem;
    font-weight: bold;
    line-height: 100%;
    margin: 1rem 0;

    @media ${(props) => props.theme.breakpoints.tablet} {
      font-size: 1.5rem;
    }
  }
  .slider-subheading {
    font-size: 1.3rem;
    font-weight: medium;
    margin: 1rem 0;
    color: ${(props) => props.theme.text.neutral};
  }
  hr {
    border: 0;
    height: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  }
`;

const LinksContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 15px;
  max-width: 14rem;

  & a {
    border: 1px solid rgb(211, 220, 230);
    padding: 7px;
    border-radius: 5px;
    width: 100px;
    margin: 5px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  @media ${(props) => props.theme.breakpoints.tablet} {
    max-width: 50%;
  }

  .btn-link {
    display: flex;
    align-items: center;
    font-size: 13px;
    padding-right: 10px;
    font-weight: bold;
    text-transform: uppercase;
    color: ${(props) => props.theme.text.secondary};
    text-decoration: none;

    @media ${(props) => props.theme.breakpoints.tablet} {
      font-size: 1rem;
      text-align: center;
      width: 180px;
      margin: 5px;
    }
  }
`;

const Stack = styled.div`
  display: flex;
  flex-direction: row;

  & img {
    width: 40px;
    height: 40px;
    margin-right: 10px;
  }
`;




export default Projects

